import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;

const Heading = tw.h1`font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-gray-900 leading-tight`;
const HeadingRow = tw.div`flex flex-col items-center text-center`;
const Text = tw.div`mt-8 text-base text-gray-600 max-w-3xl mx-auto`;

const TeamGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12`;
const TeamMember = tw.div`bg-white rounded-lg shadow-lg overflow-hidden`;
const TeamMemberImage = tw.img`w-full h-64 object-cover`;
const TeamMemberContent = tw.div`p-6`;
const TeamMemberName = tw.h3`text-xl font-semibold text-gray-900 mb-2`;
const TeamMemberRole = tw.p`text-primary-500 font-medium mb-4`;
const TeamMemberBio = tw.p`text-gray-600`;

const DepartmentSection = tw.div`mt-16`;
const DepartmentGrid = tw.div`grid grid-cols-1 md:grid-cols-2 gap-8 mt-8`;
const DepartmentCard = tw.div`bg-white rounded-lg shadow-lg p-8`;
const DepartmentTitle = tw.h3`text-xl font-semibold text-gray-900 mb-2`;
const DepartmentDescription = tw.p`text-gray-600 mb-4`;
const DepartmentMembers = tw.ul`space-y-2`;
const DepartmentMember = tw.li`flex items-center text-gray-600`;

export default () => {
  const teamMembers = [
    {
      name: "Assohoun Eddy",
      role: "CEO & Co-fondateur",
      bio: "Ingenieur et tech entrepreneur en Afrique, Eddy a fondé Tanga pour offrir aux entreprises une solution moderne, sécurisée et efficace de gestion des visiteurs. Sa vision : transformer l'accueil dans les locaux grâce à la technologie.",
      quote: "Notre mission est de rendre chaque visite plus sûre, plus rapide et plus agréable, tout en garantissant la traçabilité et la conformité.",
      image: ""
    },
    {
      name: "Paul Niango",
      role: "CTO & Co-fondateur",
      bio: "Expert en systèmes connectés et en solutions digitales, Paul conçoit des solutions robustes pour digitaliser et sécuriser l'expérience visiteur. Il croit en un accueil intelligent, fluide et respectueux de la vie privée.",
      quote: "La technologie doit simplifier l'accueil tout en renforçant la sécurité et la confidentialité des données.",
      image: ""
    },
    {
      name: "Philippe Tanny",
      role: "Associé & Expert en Securité Privée et identifications",
      bio: "Philippe accompagne les entreprises dans la digitalisation de leur accueil, en mettant l'accent sur l'efficacité et la sécurité des flux visiteurs.",
      image: ""
    },
    // {
    //   name: "Aminata Diallo",
    //   role: "Directrice Marketing",
    //   bio: "Aminata valorise l'expérience visiteur et la communication autour de la sécurité et de l'innovation apportées par Tanga.",
    //   image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    // },
    // {
    //   name: "Koffi Mensah",
    //   role: "Directeur des Opérations",
    //   bio: "Koffi optimise les processus d'accueil et de sécurité pour garantir une expérience fluide et fiable à chaque visite.",
    //   image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    // },
    // {
    //   name: "Fatou Diop",
    //   role: "Directrice des Ressources Humaines",
    //   bio: "Fatou veille à la formation continue des équipes sur les enjeux de sécurité, de confidentialité et d'accueil digital.",
    //   image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    // }
  ];

  const departments = [
    {
      title: "Direction",
      description: "L'équipe dirigeante définit la stratégie de Tanga pour offrir la meilleure solution de gestion des visiteurs, alliant sécurité, innovation et simplicité.",
      members: [
        "Assohoun Eddy - CEO",
        "Paul Niango - CTO",
        "Philippe Tanny - Associé & Expert en Securité Privée et identifications"
      ]
    },
    {
      title: "Opérations & Sécurité",
      description: "Nos experts assurent la fiabilité, la conformité et la performance de la plateforme Tanga pour tous nos clients.",
      members: [
        "Koffi Mensah - Directeur des Opérations",
        "Fatou Diop - Directrice RH",
        "Aminata Diallo - Directrice Marketing"
      ]
    }
  ];

  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>Notre Équipe</Heading>
          </HeadingRow>
          <Text>
            <p className="text-center mb-8">
              Derrière Tanga, une équipe passionnée par la sécurité, la digitalisation et l'expérience visiteur. Notre mission : rendre la gestion des visiteurs plus sûre, plus rapide et plus agréable pour tous.
            </p>
          </Text>

          <TeamGrid>
            {teamMembers.map((member, index) => (
              <TeamMember key={index}>
                <TeamMemberImage src={member.image} alt={member.name} />
                <TeamMemberContent>
                  <TeamMemberName>{member.name}</TeamMemberName>
                  <TeamMemberRole>{member.role}</TeamMemberRole>
                  <TeamMemberBio>{member.bio}</TeamMemberBio>
                </TeamMemberContent>
              </TeamMember>
            ))}
          </TeamGrid>

          <DepartmentSection>
            <HeadingRow>
              <Heading>Nos Départements</Heading>
            </HeadingRow>
            <Text>
              <p className="text-center mb-8">
                Une organisation structurée pour une efficacité optimale.
              </p>
            </Text>

            <DepartmentGrid>
              {departments.map((department, index) => (
                <DepartmentCard key={index}>
                  <DepartmentTitle>{department.title}</DepartmentTitle>
                  <DepartmentDescription>{department.description}</DepartmentDescription>
                  <DepartmentMembers>
                    {department.members.map((member, memberIndex) => (
                      <DepartmentMember key={memberIndex}>
                        <span className="mr-2">•</span>
                        {member}
                      </DepartmentMember>
                    ))}
                  </DepartmentMembers>
                </DepartmentCard>
              ))}
            </DepartmentGrid>
          </DepartmentSection>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 